/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { integer, real, sqliteTable, text } from 'drizzle-orm/sqlite-core';

export const patientVitalEntries = sqliteTable('patient_vital_entries', {
  id: text('id').primaryKey().notNull(),
  patient_id: text('patient_id'),
  recorded_at: text('recorded_at'),
  vital_definition_id: text('vital_definition_id'),
  value_number: real('value_number'),
  value_text: text('value_text'),
  value_date: text('value_date'),
  value_boolean: integer('value_boolean'),
  notes: text('notes'),
  queue_entry_id: text('queue_entry_id'),
  appointment_id: text('appointment_id'),
  encounter_id: text('encounter_id'),
  source: text('source'),
  deleted_at: text('deleted_at'),
  updated_at: text('updated_at'),
  updated_by: text('updated_by'),
});
